export default __webpack_public_path__ + "static/media/install-chat-widget3.dcf94873.JPG";